import React, { useEffect } from 'react';
import { Button, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import s from './s.module.less';
import Benefits from './Benefits';
import FAQComponent from './FAQ';
import HeroSendFaxPreview from './HeroSendFaxPreview';
import ConfirmPaymentModal from './ConfirmPaymentModal';
import { IPaymentInfo } from 'types/common';

enum ESection {
    BENEFITS = 'benefits',
    FAQ = 'faq',
}

type Props = {
    isModal?: boolean;
    paymentInfo?: IPaymentInfo;
    onPaymentInfoChange?: () => void;
    onPaid?: () => void;
};

const EFaxLandingPage = (props: Props) => {
    const { onPaid, isModal, paymentInfo, onPaymentInfoChange } = props;
    const [activeId, setActiveId] = React.useState(ESection.BENEFITS);
    const [showPayModal, setShowPayModal] = React.useState(false);

    const guideItems: TabsProps['items'] = [
        {
            key: ESection.BENEFITS,
            label: 'Benefits',
            children: <div />,
        },
        {
            key: ESection.FAQ,
            label: 'FAQs',
            children: <div />,
        },
    ];

    const handleChange = (activeKey: string) => {
        const element = document.getElementById(activeKey);
        const wrapElement = document.getElementById('efaxContentWrap');
        if (!wrapElement || !element) return;
        setActiveId(activeKey as ESection);
        wrapElement.scrollTo({
            top: element.offsetTop - 150,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        const wrap = document.getElementById('efaxContentWrap');
        const faqEl = document.getElementById(ESection.FAQ);
        if (!wrap || !faqEl) {
            return undefined;
        }
        const handle = () => {
            const top = wrap.scrollTop;
            const viewport = wrap.clientHeight;
            const threshold = top + viewport * 0.32;
            const faqTop = faqEl.offsetTop;
            setActiveId(threshold >= faqTop ? ESection.FAQ : ESection.BENEFITS);
        };
        wrap.addEventListener('scroll', handle, { passive: true });
        handle();
        return () => {
            wrap.removeEventListener('scroll', handle);
        };
    }, []);

    return (
        <div className={`${s.wrap} ${isModal ? s.wrapModal : ''}`} id="efaxContentWrap">
            <div className={s.header}>
                <div className={s.left}>
                    <div className={s.title}>
                        Secure, HIPAA-compliant <span className={s.highlight}>eFax</span> — built directly into Klarity
                    </div>
                    <div className={s.des}>
                        With <span className={s.bold}>Klarity eFax</span>, you can easily send and receive medical faxes
                        without ever leaving the platform. Starting at
                        <span className={s.bold}> $9.90/month</span> per fax number, with
                        <span className={s.bold}> 250 pages </span>
                        included each month.
                    </div>
                    {!isModal && (
                        <div className={s.startBtn}>
                            <Button type="primary" onClick={() => setShowPayModal(true)}>
                                Get started
                            </Button>
                        </div>
                    )}
                </div>
                <HeroSendFaxPreview />
            </div>
            <div className={s.tabs}>
                <Tabs
                    activeKey={activeId}
                    items={guideItems}
                    onChange={(activeKey) => handleChange(activeKey)}
                    className={s.guideTabs}
                />
            </div>
            <div className={s.content} id={ESection.BENEFITS}>
                <Benefits />
            </div>
            <div className={s.content} id={ESection.FAQ}>
                <FAQComponent />
            </div>
            {!isModal && (
                <ConfirmPaymentModal
                    open={showPayModal}
                    onClose={() => setShowPayModal(false)}
                    price={9.9}
                    paymentInfo={paymentInfo}
                    onPaymentInfoChange={onPaymentInfoChange}
                    onSuccess={() => {
                        setShowPayModal(false);
                        onPaid?.();
                    }}
                />
            )}
        </div>
    );
};

export default EFaxLandingPage;
